// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"154":"d83ad269","177":"45a16041","654":"0743a9dc","667":"d83ad269"}[chunkId] + ".css";
};